import { fromJS } from 'immutable'
import {
  PUBLIC_HOLIDAY_GET_REQUEST,
  PUBLIC_HOLIDAY_GET_SUCCESS,
  PUBLIC_HOLIDAY_GET_FAILURE,
  PUBLIC_HOLIDAY_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PUBLIC_HOLIDAY_GET_REQUEST:
      return state
        .set('isFetching', true)
    case PUBLIC_HOLIDAY_GET_SUCCESS:
      return state
        .set('isFetching', false)
        .set('holiday', fromJS(action.payload.holiday))
    case PUBLIC_HOLIDAY_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case PUBLIC_HOLIDAY_GET_RESET:
      return state
        .delete('holiday')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/public-holiday/public-holiday-get-reducer.js